export default {
  translation: {
    common: {
      emailOrUsername: 'Email alebo používateľské meno',
      invalidUsernameOrPassword: 'Nesprávne užívateľské meno alebo heslo',
      logInToBoards: 'Prihlásiť',
      noInternetConnection: 'Bez pripojenia k internetu',
      pageNotFound_title: 'Stránka neexistuje',
      password: 'Heslo',
      serverConnectionFailed: 'Pripojenie k serveru zlyhalo',
      unknownError: 'Neznáma chyba, skúste to neskôr',
    },

    action: {
      logIn: 'Prihlásiť sa',
    },
  },
};
